"use client"

import { useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { InviteUserForm } from "@/components/admin/invite-user-form"
import { UserManagementPage } from "@/components/user-management/user-management-page"
import { usersQueryKey } from "@/hooks/queries/users"
import { usePermissions } from "@/hooks/use-permissions"
import { USERS_PERMISSIONS } from "@/lib/auth/permissions.constants"

export function UserManagementWithInvite() {
  const [showInviteForm, setShowInviteForm] = useState(false)
  const queryClient = useQueryClient()
  const { activeTenantId, can } = usePermissions()
  const canCreateUsers = can(USERS_PERMISSIONS.CREATE)

  const handleBackToList = () => {
    setShowInviteForm(false)
    void queryClient.invalidateQueries({ queryKey: usersQueryKey(activeTenantId) })
  }

  if (showInviteForm && canCreateUsers) {
    return (
      <div className="p-6">
        <div className="max-w-2xl mx-auto">
          <Button variant="ghost" onClick={handleBackToList} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            <span>Back to User Management</span>
          </Button>
          <InviteUserForm onSuccess={handleBackToList} />
        </div>
      </div>
    )
  }

  return (
    <div>
      <UserManagementPage onInvite={canCreateUsers ? () => setShowInviteForm(true) : undefined} />
    </div>
  )
}
